
window.addEventListener( "pageshow", function ( event ) {
  var historyTraversal = event.persisted || 
                         ( typeof window.performance != "undefined" && 
                              window.performance.navigation.type === 2 );
  if ( historyTraversal ) {
    // Handle page restore.
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.location.reload();
    }, 500);
    
  }
  console.log('working')
});

/*document.querySelectorAll(".capsule-button").forEach((btn, index) => {
  btn.addEventListener("click", () => {
    gsap.to(window, {duration: 0.4, scrollTo:{y:"#color-" + (index + 1), offsetY:0}});
  });
});
*/

  document.querySelectorAll(".capsule-button").forEach((btn, index) => {
    btn.addEventListener("click", () => {
      const header = document.querySelector('.header, .shopify-section-header-sticky');
      const headerHeight = header ? header.offsetHeight : 0;
      
      gsap.to(window, {
        duration: 0.4, 
        scrollTo:{
          y:"#color-" + (index + 1), 
          offsetY: headerHeight
        },
        ease: "power2.out"
      });
    });
  });
 /*
  // Simple scroll snap with half-point threshold
  let isScrolling = false;
  let timeout;
  
  function snapToSection() {
    if (isScrolling) return;
    
    const header = document.querySelector('.header, .shopify-section-header-sticky');
    const headerHeight = header ? header.offsetHeight : 0;
    const sections = document.querySelectorAll('[id^="color-"]');
    const currentScroll = window.pageYOffset;
    const viewportCenter = currentScroll + window.innerHeight / 2;
    
    // Find which section's center is closest to viewport center
    let closestSection = null;
    let closestDistance = Infinity;
    
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      const sectionTop = section.offsetTop - headerHeight;
      const sectionCenter = sectionTop + section.offsetHeight / 2;
      const distance = Math.abs(viewportCenter - sectionCenter);
      
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSection = section;
      }
    }
    
    if (closestSection) {
      isScrolling = true;
      gsap.to(window, {
        duration: 0.5,
        scrollTo: { 
          y: closestSection, 
          offsetY: headerHeight 
        },
        ease: "power2.out",
        onComplete: () => { 
          isScrolling = false;
        }
      });
    }
  }
  
  // Simple scroll listener
  window.addEventListener('scroll', () => {
    if (isScrolling) return;
    clearTimeout(timeout);
    timeout = setTimeout(snapToSection, 100);
  }, { passive: true });
  
  
  */
/* tagsonar js ends*/

$(document).ready(
  function () {
    if ($(".black")[0]){
      gsap.registerPlugin(ScrollTrigger);
      
      gsap.set(".panel", { zIndex: (i, target, targets) => 1 + targets.length - i });
      gsap.set(".panel2", { zIndex: (i, target, targets) => 1 + targets.length - i });
      gsap.set(".panel3", { zIndex: (i, target, targets) => 1 + targets.length - i });
      gsap.set(".panel4", { zIndex: (i, target, targets) => 1 + targets.length - i });
      gsap.set(".panel5", { zIndex: (i, target, targets) => 1 + targets.length - i });
      gsap.set(".panel6", { zIndex: (i, target, targets) => 1 + targets.length - i });
      if ($(".panel7")[0]) {
        gsap.set(".panel7", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel8")[0]) {
        gsap.set(".panel8", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel9")[0]) {
        gsap.set(".panel9", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel10")[0]) {
        gsap.set(".panel10", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel11")[0]) {
        gsap.set(".panel11", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel12")[0]) {
        gsap.set(".panel12", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel13")[0]) {
        gsap.set(".panel13", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel14")[0]) {
        gsap.set(".panel14", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel15")[0]) {
        gsap.set(".panel15", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel16")[0]) {
        gsap.set(".panel16", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel17")[0]) {
        gsap.set(".panel17", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel18")[0]) {
        gsap.set(".panel18", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel19")[0]) {
        gsap.set(".panel19", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }
      if ($(".panel20")[0]) {
        gsap.set(".panel20", { zIndex: (i, target, targets) => 1 + targets.length - i });
      }

      gsap.set(".panel-text", {height: window.innerHeight});

      var heightOfWindow = window.innerHeight;
      
      // var images = gsap.utils.toArray(".panel:not(:last-child)");
         var images = gsap.utils.toArray('.panel');

      
      ScrollTrigger.create({
      
        trigger: "section.black",
        start: () => "top top",
        end: () => "+=" + ((images.length) * window.innerHeight),
        invalidateOnRefresh: true,
      });
      

      // Sync panel-1 images with panel-text1 entry point
      var panelText1Distance = $(".panel-text1").offset().top;
      var image1Height = $(".p-wrap-1").height();
      var windowHeight = $(window).height();
      // Start when panel-text1 enters viewport (top hits bottom of viewport)
      // This matches when text animation starts
      var start1 = panelText1Distance - windowHeight;
      var end1 = start1 + image1Height;
      
      images.forEach((image, i) => {
        var tl = gsap.timeline({
          scrollTrigger: {
            id: "panel-1",
            trigger: ".trigger-wrap",  
            start: () => "top+=" + start1 + " -" + (heightOfWindow * i),
            end: () => "top+=" + end1 + " -" + (heightOfWindow * i),
            scrub: true,
            invalidateOnRefresh: true,
          }
        })
      
        tl.fromTo(image, { height: () => { return "100%" }, duration: 1.0, ease: "none" }, 
                         { height: () => { return "0%" }, duration: 1.0, ease: "none" });
      });
      
      // Sync panel2 images with panel-text2 entry point
      var panelText2Distance = $(".panel-text2").offset().top;
      var image2Height = $(".p-wrap-2").height();
      var windowHeight = $(window).height();
      var start2 = panelText2Distance - windowHeight;
      
      var images2 = gsap.utils.toArray('.panel2');

      images2.forEach((image, i) => {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".trigger-wrap",  
            start: () => "top+=" + start2 + " -" + (heightOfWindow * i),
            end: () => "+=" + image2Height,
            scrub: true,
            invalidateOnRefresh: true,
          }
        })
      
        tl.fromTo(image, { height: () => { return "100%" }, duration: 1.0, ease: "none" }, 
                         { height: () => { return "0%" }, duration: 1.0, ease: "none" });
      });

      // Sync panel3 images with panel-text3 entry point
      var panelText3Distance = $(".panel-text3").offset().top;
      var image3Height = $(".p-wrap-3").height();
      var windowHeight = $(window).height();
      var start3 = panelText3Distance - windowHeight;

      var images3 = gsap.utils.toArray('.panel3');

      images3.forEach((image, i) => {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".trigger-wrap",  
            start: () => "top+=" + start3 + " -" + (heightOfWindow * i),
            end: () => "+=" + image3Height + "",
            scrub: true,
            invalidateOnRefresh: true,
          }
        })
      
        tl.fromTo(image, { height: () => { return "100%" }, duration: 0.1, ease: "none" }, 
                         { height: () => { return "0%" }, duration: 0.1, ease: "none" });
      });

      // Sync panel4 images with panel-text4 entry point
      var panelText4Distance = $(".panel-text4").offset().top;
      var image4Height = $(".p-wrap-4").height();
      var windowHeight = $(window).height();
      var start4 = panelText4Distance - windowHeight;

      var images4 = gsap.utils.toArray('.panel4');

      images4.forEach((image, i) => {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".trigger-wrap",  
            start: () => "top+=" + start4 + " -" + (heightOfWindow * i),
            end: () => "+=" + image4Height,
            scrub: true,
            invalidateOnRefresh: true,   
          }
        })
      
        tl.fromTo(image, { height: () => { return "100%" }, duration: 0.1, ease: "none" }, 
                         { height: () => { return "0%" }, duration: 0.1, ease: "none" });
      });

      // Sync panel5 images with panel-text5 entry point
      var panelText5Distance = $(".panel-text5").offset().top;
      var image5Height = $(".p-wrap-5").height();
      var windowHeight = $(window).height();
      var start5 = panelText5Distance - windowHeight;

      var images5 = gsap.utils.toArray('.panel5');

      images5.forEach((image, i) => {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".trigger-wrap",  
            start: () => "top+=" + start5 + " -" + (heightOfWindow * i),
            end: () => "+=" + image5Height,
            scrub: true,
            invalidateOnRefresh: true,  
          }
        })
      
        tl.fromTo(image, { height: () => { return "100%" }, duration: 0.1, ease: "none" }, 
                         { height: () => { return "0%" }, duration: 0.1, ease: "none" });
      });

      // Sync panel6 images with panel-text6 entry point
      var panelText6Distance = $(".panel-text6").offset().top;
      var image6Height = $(".p-wrap-6").height();
      var windowHeight = $(window).height();
      var start6 = panelText6Distance - windowHeight;

      var images6 = gsap.utils.toArray('.panel6');

      images6.forEach((image, i) => {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".trigger-wrap",  
            start: () => "top+=" + start6 + " -" + (heightOfWindow * i),
            end: () => "+=" + image6Height,
            scrub: true,
            invalidateOnRefresh: true,
          }
        })
      
        tl.fromTo(image, { height: () => { return "100%" }, duration: 0.1, ease: "none" }, 
                         { height: () => { return "0%" }, duration: 0.1, ease: "none" });
      });

      // Sync panel7 images with panel-text7 entry point
      var panelText7Distance = $(".panel-text7").offset().top;
      var image7Height = $(".p-wrap-7").height();
      var windowHeight = $(window).height();
      var start7 = panelText7Distance - windowHeight;

      var images7 = gsap.utils.toArray('.panel7');

      images7.forEach((image, i) => {
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: ".trigger-wrap",  
            start: () => "top+=" + start7 + " -" + (heightOfWindow * i),
            end: () => "+=" + image7Height,
            scrub: true,
            invalidateOnRefresh: true,   
          }
        })
      
        tl.fromTo(image, { height: () => { return "100%" }, duration: 0.1, ease: "none" }, 
                         { height: () => { return "0%" }, duration: 0.1, ease: "none" });
      });
      
    }
  }
)

$(document).ready(
    function() {
        if ($(".black")[0]) {
          gsap.registerPlugin(ScrollTrigger);
  
          var tl3 = gsap.timeline({
              scrollTrigger: {
                  trigger: ".footer",
                  start: "top bottom",
                  end: "bottom bottom",
                  toggleActions: "play none none reset",
              }
          })
  
          tl3.to(".black", {position:"absolute", bottom: 0, top: "unset"})
          tl3.to(".capsule-buttons.coloured-boxes", {position:"absolute"},"<")


          if ($(".panel-text2")[0]) {
            var progresstimeline1 = gsap.timeline({
                scrollTrigger: { 
                id: "box",
                trigger: ".panel-text2",
                scrub: true,
                start: "top bottom",
                end: "bottom bottom",
                toggleActions: "play none none reset",
                }
            }) 
            
            
            if ($(".capsule-button-border")[0]) {
              progresstimeline1.to(".capsule-button-border", { x: 33})
            }
            if ($(".category-nav-button")[0]) {
              progresstimeline1.to(".category-nav-button.first", {duration: 0.5, color: "#B5B5B5"})
              progresstimeline1.to(".category-nav-button.second", {duration: 0.5, color: "#000000"})
            }
          }

          if ($(".panel-text3")[0]) {
            var progresstimeline2 = gsap.timeline({
                scrollTrigger: { 
                id: "box",
                trigger: ".panel-text3",
                scrub: true,
                start: "top bottom",
                end: "bottom bottom",
                }
            }) 
            
            
            if ($(".capsule-button-border")[0]) {
              progresstimeline2.to(".capsule-button-border", { x: 66})
            }
            if ($(".category-nav-button")[0]) {
              progresstimeline2.to(".category-nav-button.second", {duration: 0.5, color: "#B5B5B5"})
              progresstimeline2.to(".category-nav-button.third", {duration: 0.5, color: "#000000"})
            }
          }

          if ($(".panel-text4")[0]) {
            var progresstimeline3 = gsap.timeline({
                scrollTrigger: { 
                id: "box",
                trigger: ".panel-text4",
                scrub: true,
                start: "top bottom",
                end: "bottom bottom",
                }
            }) 
            
            
            if ($(".capsule-button-border")[0]) {
              progresstimeline3.to(".capsule-button-border", { x: 99})
            }
            if ($(".category-nav-button")[0]) {
              progresstimeline3.to(".category-nav-button.third", {duration: 0.5, color: "#B5B5B5"})
              progresstimeline3.to(".category-nav-button.fourth", {duration: 0.5, color: "#000000"})
            }
          }
          

          if ($(".panel-text5")[0]) {
            var progresstimeline4 = gsap.timeline({
                scrollTrigger: { 
                id: "box",
                trigger: ".panel-text5",
                scrub: true,
                start: "top bottom",
                end: "bottom bottom",
                }
            }) 
          
          
            if ($(".capsule-button-border")[0]) {
              progresstimeline4.to(".capsule-button-border", { x: 132})
            }
            if ($(".category-nav-button")[0]) {
              progresstimeline4.to(".category-nav-button.fourth", {duration: 0.5, color: "#B5B5B5"})
              progresstimeline4.to(".category-nav-button.fifth", {duration: 0.5, color: "#000000"})
            }
          }

          if ($(".panel-text6")[0]) {
            var progresstimeline5 = gsap.timeline({
                scrollTrigger: { 
                id: "box",
                trigger: ".panel-text6",
                scrub: true,
                start: "top bottom",
                end: "bottom bottom",
                }
            }) 
          
          
              if ($(".capsule-button-border")[0]) {
                progresstimeline5.to(".capsule-button-border", { x: 165})
              }
              if ($(".category-nav-button")[0]) {
                progresstimeline5.to(".category-nav-button.fifth", {duration: 0.5, color: "#B5B5B5"})
                progresstimeline5.to(".category-nav-button.sixth", {duration: 0.5, color: "#000000"})
              }
          }

          if ($(".panel-text7")[0]) {
            var progresstimeline6 = gsap.timeline({
                scrollTrigger: { 
                id: "box",
                trigger: ".panel-text7",
                scrub: true,
                start: "top bottom",
                end: "bottom bottom",
                }
            }) 
            
            if ($(".capsule-button-border")[0]) {
                progresstimeline6.to(".capsule-button-border", { x: 198})
              }
            if ($(".category-nav-button")[0]) {
              progresstimeline6.to(".category-nav-button.sixth", {duration: 0.5, color: "#B5B5B5"})
              progresstimeline6.to(".category-nav-button.seventh", {duration: 0.5, color: "#000000"})
            }
          }
        }
    }
);



$(document).ready(
  function() {
    if ($(".category-panel")[0]) {
      var i = 1;
      $('.p-wrap').each(function() {
        var index = 'p-wrap-' + i;
        $(this).addClass(index);
        i++;
        if (i == 8) {
            i = 1;
        }
      });
    };
  }
)
// $(document).ready( 
//   function() {
//       if ($(".category-panel")[0]) {
//         gsap.registerPlugin(ScrollTrigger);

//         var tl3 = gsap.timeline({
//             scrollTrigger: {
//                 trigger: ".footer",
//                 start: "top bottom",
//                 end: "bottom bottom",
//                 toggleActions: "play none none reset",
//             }
//         })

//         tl3.to(".panel-text.category-panel", {position:"absolute", top: "unset", bottom: 0})
//       }
//   }
// )



// Homepage svg animation

$(document).ready(
  function() {
    if ($(".gallery-section")[0]) {
      gsap.registerPlugin(ScrollTrigger);

      var tl4 = gsap.timeline({
          scrollTrigger: {
              id: "gallery",
              trigger: ".gallery-section",
              start: "top 50%",
              end: "bottom bottom",
              toggleActions: "play none none reverse",
          }
      })

      tl4.from(".gallery-section .container", {duration: 1, opacity: 0, yPercent:100})

      var bgLogo = document.getElementById("logo-bg-svg");
      var logoHeight = $(bgLogo).height();
      var viewportHeight = $(window).height();
      
      $(window).resize(function(){
        bgLogo = document.getElementById("logo-bg-svg");
        logoHeight = $(bgLogo).height();
      });

      if (window.screen.width > 767) {
        var tl5 = gsap.timeline({
            scrollTrigger: {
                id: "logo-svg1",
                trigger: ".gallery-section",
                scrub: 0,
                start: "top top+=" + (viewportHeight - 25),
                end: "top+=" + (logoHeight) + " top+=" + (viewportHeight - 25),
                toggleActions: "play none none reverse", 
            }
        })
      } else {
        var tl5 = gsap.timeline({
            scrollTrigger: {
                id: "logo-svg1",
                trigger: ".gallery-section",
                scrub: 0,
                start: "top top+=" + (viewportHeight + 50),
                end: "top+=" + (logoHeight) + " top+=" + (viewportHeight + 50),
                toggleActions: "play none none reverse", 
            }
        })
        
      }

      tl5.to("#logo-bg #clipRect", { height: 0, duration: 1, ease: "none" });

      var tl6 = gsap.timeline({
          scrollTrigger: {
              id: "logo-svg2",
              trigger: ".gallery-section",
              start: "top -40%",
              end: "bottom bottom",
              toggleActions: "play none none reverse", 
            
          }
      })

      tl6.to("#logo-bg-pink .container svg path", {duration: 1.2, fill: "#CECBE7",})
      tl6.to(".gallery-section", {duration: 1.2, background: "#4E595A"},"<")
      tl6.to(".full-width-image-section", {duration: 1.2, background: "#4E595A"},"<")


      if (window.screen.width > 767) {
        var tl7 = gsap.timeline({
            scrollTrigger: {
                id: "logo-svg3",
                trigger: ".full-width-image-section",
                scrub: 0,
                start: "top+=60 top+=" + (viewportHeight - 25),
                end: "top+=" + (logoHeight + 60) + " top+=" + (viewportHeight - 25),
                toggleActions: "play none none reverse",
            }
        })
      } else {
        var tl7 = gsap.timeline({
            scrollTrigger: {
                id: "logo-svg3",
                trigger: ".full-width-image-section",
                scrub: 0,
                start: "top+=60 top+=" + (viewportHeight + 50),
                end: "top+=" + (logoHeight + 60) + " top+=" + (viewportHeight + 50),
                toggleActions: "play none none reverse",
            }
        })
      }

      tl7.to("#logo-bg-pink #clipRectPink", { height: 0, duration: 1.0, ease: "none", delay: 0 }, 0);

      if (window.screen.width > 767) {
        var tl8 = gsap.timeline({
            scrollTrigger: {
                id: "footer-logo",
                trigger: ".footer",
                scrub: 0,
                start: "top top+=" + (viewportHeight - 25),
                end: "top+=" + (logoHeight) + " top+=" + (viewportHeight - 25),
                toggleActions: "play none none reverse",
            }
        })
      } else {
        var tl8 = gsap.timeline({
            scrollTrigger: {
                id: "footer-logo",
                trigger: ".footer",
                scrub: 0,
                start: "top top+=" + (viewportHeight + 50),
                end: "top+=" + (logoHeight) + " top+=" + (viewportHeight + 50),
                toggleActions: "play none none reverse",
            }
        })
      }

      tl8.to("#logo-bg-pink2 #clipRectPink2", { height: 0, duration: 1.0, ease: "none", delay: 0 }, 0);

      var tl9 = gsap.timeline({
          scrollTrigger: {
              id: "footer-logo1",
              trigger: ".footer",
              start: "top+=" + (viewportHeight) + " bottom",
              end: "top bottom",
              toggleActions: "play none none reverse",
          }
      })

      tl9.to("#logo-bg-footer", { bottom: 25, top: "unset", duration: 0.0, ease: "none" });

    }
  }
);


// About Page

$(document).ready(
  function() {
    if ($(".about-green-section")[0]) {
      gsap.registerPlugin(ScrollTrigger);

      var tl = gsap.timeline({
          scrollTrigger: {
              id: "about_one",
              trigger: ".blue-text-overlay-section",
              start: "top top",
              end: "bottom bottom",
              toggleActions: "play none none reverse",
          }
      })

      tl.to(".about-background-section.blue", {duration: 0.1, opacity: 0})
      

      var tl2 = gsap.timeline({
          scrollTrigger: {
              id: "about_two",
              trigger: ".green-text-overlay-section",
              start: "top top",
              end: "bottom bottom",
              toggleActions: "play none none reverse",
          }
      })

      tl2.to(".about-background-section.green", {duration: 0.1, opacity: 0})
      


      var tl3 = gsap.timeline({
          scrollTrigger: {
            id: "about_three",
            trigger: ".footer",
            start: "top bottom",
            end: "bottom bottom",
            toggleActions: "play none none reverse",
          }
      })

      tl3.to(".brown-text-overlay-section", {duration: 0.0, zIndex: 3, backgroundColor: "#230e03", ease: "none"})
      
    }
  }
);


// Homepage svg animation

// $(document).ready(
//   function() {
//     if ($(".collection.category-grid")[0]) {
//       gsap.registerPlugin(ScrollTrigger);

//       var tl = gsap.timeline({
//           scrollTrigger: {
//               id: "category_one",
//               trigger: ".footer",
//               start: "top bottom",
//               end: "bottom bottom",
//               toggleActions: "play none none reverse",
//           }
//       })

//       tl.to(".capsule-buttons.coloured-boxes.category-nav-buttons", {position:"absolute"})
//     }
//   }
// )


$(document).ready(
  function() {
    if ($(".category-nav-highlight")[0]) {

      gsap.registerPlugin(ScrollTrigger);

      if ($("#color-1")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-1",
                start: "top bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category1", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }


      if ($("#color-2")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-2",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category2", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }


      if ($("#color-3")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-3",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
    3
        tl3.to("#button-category3", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }


      if ($("#color-4")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-4",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category4", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }


      if ($("#color-5")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-5",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category5", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }


      if ($("#color-6")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-6",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category6", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }


      if ($("#color-7")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-7",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category7", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }


      if ($("#color-8")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-8",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category8", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }


      if ($("#color-9")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-9",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category9", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }


      if ($("#color-10")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-10",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category10", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }

      if ($("#color-11")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-11",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category11", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }

      
      if ($("#color-12")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-12",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category12", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }

      if ($("#color-13")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-13",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category13", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }

      if ($("#color-14")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-14",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category14", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }

      if ($("#color-15")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-15",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category15", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }

      if ($("#color-16")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-16",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category16", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }

      if ($("#color-17")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-17",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category17", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }

      if ($("#color-18")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-18",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category18", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }

      if ($("#color-19")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-19",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category19", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }

      if ($("#color-20")[0]) {
        var tl3 = gsap.timeline({
            scrollTrigger: {
                trigger: "#color-20",
                start: "top+=200 bottom",
                end: "bottom+=200 bottom",
                toggleActions: "play reverse play reverse",
            }
        })
      
        tl3.to("#button-category20", {border:"1px solid black", color: '#fff', backgroundColor: '#000', duration: 0.1, ease: "none"})
      }
    }
  }
);



// Open search modal

$(document).ready(function() {
  $("#open_search").click(function () {
    $(".search-modal").toggleClass("is-active");
  });
});

$(document).ready(function() {
  $(".close-search-bar").click(function () {
    $(".search-modal").toggleClass("is-active");
  });
});




// Menu Drawer Close Button

$(document).ready(function() {
  $("#menu_drawer_close").click(function () {
    $("#Details-menu-drawer-container").removeClass("menu-opening");
    $("#Details-menu-drawer-container").removeAttr("open");
    $("#shopify-section-header").removeClass("menu-open");
  });
});



// Product Images

var wheel, scrolling;
var $carousel = $(".product-images-slider");
$carousel.on("init", () => {
	wheel = new WheelIndicator({
		elem: $carousel[0],
		callback: wheelHandler,
	});
})
.on("beforeChange", () => {
	scrolling = true;
})
.on("afterChange", () => {
	scrolling = false;
})

const slider = $(".product-images-slider");
slider.slick({
  slidesToScroll: 1,
  slidesToShow: 1,
  arrows: true,
  dots: false,
  asNavFor: ".slider-nav-thumbnails",
  vertical: false,
  verticalSwiping: false,
  infinite: true,
  draggable: false,
  prevArrow: '<button type="button" class="slick-prev custom-arrow"><code><</code></button>',
  nextArrow: '<button type="button" class="slick-next custom-arrow"><code>></code></button>',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
      vertical: false,
      verticalSwiping: false,
    }
  }]
});

const sliderTwo = $(".slider-nav-thumbnails");
sliderTwo.slick({
  slidesToScroll: 1,
  asNavFor: ".product-images-slider",
  arrows: false,
  dots: false,
  focusOnSelect: true,
  variableWidth: true,
  vertical: true,
  infinite: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
      vertical: false,
    }
  }]
});

function wheelHandler(e) {
	if (!scrolling) {
      if($(window).width() >= 1200) {
		$carousel.slick(e.direction === "up" ? "slickPrev" : "slickNext");
      }
	}
}

// Remove active class from all thumbnail slides
$(".slider-nav-thumbnails .slick-slide").removeClass("slick-active");

// Set active class to first thumbnail slides
$(".slider-nav-thumbnails .slick-slide").eq(0).addClass("slick-active");

// On before slide change match active thumbnail to current slide
$(".product-images-slider").on("beforeChange", function (event, slick, currentSlide, nextSlide) {
  var mySlideNumber = nextSlide;
  $(".slider-nav-thumbnails .slick-slide").removeClass("slick-active");
  $(".slider-nav-thumbnails .slick-slide").eq(mySlideNumber).addClass("slick-active");
});

$("#variant_fieldset-color input:radio").change(function(){
  if ($(this).is(":checked")) {
    $(".radio-input").removeClass("checked");
    $(".variant-color-label").removeClass("checked");
    $(this).addClass("checked");
    $(this).next().addClass("checked");
  }
});
   
// $(".color-radios").on("click", function () {
//   var thisClick = $(this);
//   var v = $(thisClick).next().children("input:first");
//   v.click();

// });


/* When the user clicks on the button, 
toggle between hiding and showing the dropdown content */
function myFunction() {
  document.getElementById("sortDropdown").classList.toggle("show");
}

// Close the dropdown if the user clicks outside of it
window.onclick = function(event) {
  if (!event.target.matches(".dropbtn")) {
    var dropdowns = document.getElementsByClassName("sort-dropdown-content");
    var i;
    for (i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains("show")) {
        openDropdown.classList.remove("show");
      }
    }
  }
}

// Open size list: card-product

// $(document).ready(function() {
//   if ($(".card-size-show-btn")[0]) {
//     $(".card-size-show-btn").click(function () {
//       $(this).parent().siblings().find(".size-radios").addClass("is-active");
//       $(this).addClass("hide");
//       $(this).siblings(".product-form").addClass("show");
//     });
//   }
// });

// Open facets mobile
$(document).ready(function() {
  if ($(".facets-mobile-opener")[0]) {
    $(".facets-mobile-opener").click(function () {
      $("#main-collection-filters").toggleClass("open");
      $(".facets-opener-svg").toggleClass("open");
    });
  }
});

// Hide categories panel text when mobile menu open
$(document).ready(function() {
  if ($(".panel-text")[0]) {
    $(".header__icon--menu").click(function () {
      $(".panel-text").addClass("d-none");
    });
    $("#menu_drawer_close").click(function () {
      $(".panel-text").removeClass("d-none");
    });
  }
});

// FAQ open close symbol
$(document).ready(function() {
  if ($(".ffaq-open-close")[0]) {
    $(".faq-open-close").click(function () {
      $(".faq-open-close").toggleClass("open");
    });
  }
});

// Add border to Nav when dropdown menu open
// $(document).ready(function() {
//   $("#Details-HeaderMenu-2").click(function() {
//     $("#shopify-section-header").toggleClass("border-on"); 
//   })
// });
$(document).ready(function() {
  $("#shopify-section-header").addClass("border-on");
});

// Coloured words to fade behind images after 2 seconds
$(document).ready(function() {
  setTimeout(function() {
    $(".panel-collection-name").addClass("behind");
    $(".category-panel").addClass("behind");
  }, 2000)
});

$(window).on("scroll", function () {
  $(".panel-collection-name").removeClass("behind");
  $(".category-panel").removeClass("behind");
  
});

$(window).scroll(function() {
    clearTimeout($.data(this, "scrollTimer"));
    $.data(this, "scrollTimer", setTimeout(function() {
      $(".panel-collection-name").addClass("behind");
      $(".category-panel").addClass("behind");
    }, 2000));
});

//Bring forward when hover
if ($(".trigger-wrap")[0]) {
  $(".panel-collection-name").mouseover(function() {
    $(".panel-collection-name").removeClass("behind");
    $(".category-panel").removeClass("behind");
  }).mouseout(function() {
      $(".panel-collection-name").addClass("behind");
        $(".category-panel").addClass("behind")
  });
}

// When one accordion open close rest
const All_Details = document.querySelectorAll("details.accordian-details");

All_Details.forEach(deet=>{
  deet.addEventListener("toggle", toggleOpenOneOnly)
})

function toggleOpenOneOnly(e) {
  if (this.open) {
    All_Details.forEach(deet=>{
      if (deet!=this && deet.open) deet.open = false
    });
  }
}

// Set starting VH
$(document).ready(function () {
  let viewportHeight = $(window).height();
  $("#logo-bg").height(viewportHeight);
  $("#logo-bg-pink").height(viewportHeight);
  $("#logo-bg-pink2").height(viewportHeight);
  $("#logo-bg-footer").height(viewportHeight);
  // $(".about-background-section").height(viewportHeight + 40);
})

// Zoom
$(document).ready(function(){

  if ($(window).width() > 992) {
    $("img.product-image-image").each(function() {
      var $img = $(this);
      // Wrap image in a span that matches its dimensions exactly
      $img.wrap('<span class="zoom-wrapper" style="display:inline-block; position: relative; overflow: hidden;"></span>');
      var $wrapper = $img.parent();
      // Set wrapper dimensions to match image
      $wrapper.css({
        width: $img.outerWidth() + 'px',
        height: $img.outerHeight() + 'px'
      });
      $img.css("display", "block");
      // Apply zoom to the wrapper
      $wrapper.zoom({ on:"grab" });
    });
  }
});

$(document).ready(function(){
  if ($(window).width() < 992) {
    $("img.product-image-image").addClass("image-magnify-lightbox")
  }
});

// Fix carousel layout when product modal closes on mobile
$(document).ready(function(){
  // Listen for modal closed event
  document.body.addEventListener('modalClosed', function() {
    // Only fix on mobile
    if ($(window).width() < 992) {
      // Small delay to ensure modal is fully closed and DOM is updated
      setTimeout(function() {
        var $slider = $(".product-images-slider");
        var $sliderTwo = $(".slider-nav-thumbnails");
        
        // Refresh Slick carousel to fix layout issues
        if ($slider.length && $slider.hasClass('slick-initialized')) {
          // Get current slide before refresh
          var currentSlide = $slider.slick('slickCurrentSlide');
          
          // Refresh the carousel position
          $slider.slick('setPosition');
          
          // Trigger resize to recalculate dimensions
          $(window).trigger('resize');
          
          // Ensure carousel buttons are accessible
          $slider.find('.slick-arrow').css({
            'position': 'absolute',
            'z-index': '1'
          });
        }
        
        if ($sliderTwo.length && $sliderTwo.hasClass('slick-initialized')) {
          $sliderTwo.slick('setPosition');
          $(window).trigger('resize');
        }
        
        // Fix any overflow/padding issues on the carousel container
        $('.product-images-slider').css({
          'overflow': 'hidden',
          'height': 'auto'
        });
        
        // Recalculate heights after a brief delay to ensure all styles are applied
        setTimeout(function() {
          if ($(window).width() < 767) {
            $('.product-images-slider').css('height', '65vh');
          } else {
            $('.product-images-slider').css('height', '100%');
          }
          $slider.slick('setPosition');
        }, 50);
      }, 150);
    }
  });
});


// Scroll down on product page to hide menu

$(document).ready(function () {
  if ($("main.product")[0]) {
    setTimeout(function () {
        var y = $(window).scrollTop();
        $(window).scrollTop(y+82);
    }, 300);
  };
});

if(document.getElementById("play_button")){
  
  var playButton = document.getElementById("play_button");
  var video = document.getElementById("home-hero-video");
  // Event listener for the play/pause button
  playButton.addEventListener("click", function() {
    if (video.paused == true) {
      // Play the video
      video.play();
  
      // Update the button text to 'Pause'
      playButton.innerHTML = "Pause";
    } else {
      // Pause the video
      video.pause();
  
      // Update the button text to 'Play'
      playButton.innerHTML = "Play";
    }
  });
}

if(document.getElementById("play_button_mobile")){
  
  var playButtonMobile = document.getElementById("play_button_mobile");
  var videoMobile = document.getElementById("home-hero-video-mobile");
  // Event listener for the play/pause button
  playButtonMobile.addEventListener("click", function() {
    if (videoMobile.paused == true) {
      // Play the video
      videoMobile.play();
  
      // Update the button text to 'Pause'
      playButtonMobile.innerHTML = "Pause";
    } else {
      // Pause the video
      videoMobile.pause();
  
      // Update the button text to 'Play'
      playButtonMobile.innerHTML = "Play";
    }
  });
}

$(document).ready(function(){
    $('.Color .panel-collection-name .panel-collection-name-link').addClass(function() {
        return this.innerHTML.length > 5 ? 'long' : '';
    });
});

$( document ).ajaxComplete(function() {
  const slider = $(".product-images-slider");
  slider.slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: false,
    dots: false,
    asNavFor: ".slider-nav-thumbnails",
    vertical: true,
    verticalSwiping: false,
    infinite: false,
    draggable: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
        vertical: false,
        verticalSwiping: false,
      }
    }]
  });
  
  const sliderTwo = $(".slider-nav-thumbnails");
  sliderTwo.slick({
    slidesToScroll: 1,
    asNavFor: ".product-images-slider",
    arrows: false,
    dots: false,
    focusOnSelect: true,
    variableWidth: true,
    vertical: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
        vertical: false,
      }
    }]
  });
});